import { call, query } from "./calls";

export const Bpm = {
    create: (diagramConfig) => call("/ProcessLayout", "POST", diagramConfig),
    update: (diagramConfig) => call(`/ProcessLayout/${diagramConfig.id}`, "PUT", diagramConfig),
    delete: (id) => call(`/ProcessLayout/${id}`, "DELETE"),
    get: (id) => call(`/ProcessLayout/${id}`),
    list: () => query("select * from ProcessLayout where type='bpm'"),
    getProcessInstance: (id) => query(`select * from ProcessScope where layoutId = ${id} and active = true order by version desc`)
}